'use client';

import { Suspense } from 'react';

import { NotificacaoSelfWizard } from '@/features/notificacaoSelf';
import { LazyLoader } from '@/shared/components/ui';

const NotificacaoSelfPage = () => {
  return (
    <Suspense fallback={<LazyLoader />}>
      <NotificacaoSelfWizard />
    </Suspense>
  );
};

export default NotificacaoSelfPage;
